import * as types from './forecastActionType';

//Fetch Forecast Reports Tab Actions
export const fetchForecastReportsTabRequest = (payload) => ({
    type: types.FETCH_FORECAST_REPORTS_TAB_REQUEST,
    payload,
});
export const fetchForecastReportsTabSuccess = (payload) => ({
    type: types.FETCH_FORECAST_REPORTS_TAB_SUCCESS,
    payload,
});
export const fetchForecastReportsTabFailure = (error) => ({
    type: types.FETCH_FORECAST_REPORTS_TAB_FAILURE,
    error,
});

//Delete Forecast Reports Tab Actions
export const deleteForecastReportRequest = (payload) => ({
    type: types.DELETE_FORECAST_REPORTS_REQUEST,
    payload,
});
export const deleteForecastReportSuccess = (payload) => ({
    type: types.DELETE_FORECAST_REPORTS_SUCCESS,
    payload,
});
export const deleteForecastReportFailure = (error) => ({
    type: types.DELETE_FORECAST_REPORTS_FAILURE,
    error,
});

// Notes Edit Actions
export const fetchForecastNotesEditRequest = (payload) => ({
    type: types.FETCH_FORECAST_NOTES_EDIT_REQUEST,
    payload,
});
export const fetchForecastNotesEditSuccess = (payload) => ({
    type: types.FETCH_FORECAST_NOTES_EDIT_SUCCESS,
    payload,
});
export const fetchForecastNotesEditFailure = (error) => ({
    type: types.FETCH_FORECAST_NOTES_EDIT_FAILURE,
    error,
});

//Notes Save Actions
export const fetchForecastNotesSaveRequest = (payload) => ({
    type: types.FETCH_FORECAST_NOTES_SAVE_REQUEST,
    payload,
}); 
export const fetchForecastNotesSaveSuccess = (payload) => ({
    type: types.FETCH_FORECAST_NOTES_SAVE_SUCCESS,
    payload,
});
export const fetchForecastNotesSaveFailure = (error) => ({
    type: types.FETCH_FORECAST_NOTES_SAVE_FAILURE,
    error,
});

export const fetchAllForecastingDemandDropdownsRequest = (data) => ({
    type: types.GET_ALL_FORECASTING_DEMAND_DROPDOWNS_REQUEST,
    payload: data,
});
export const fetchAllForecastingDemandDropdownsSuccess = (data) => ({
    type: types.GET_ALL_FORECASTING_DEMAND_DROPDOWNS_SUCCESS,
    payload: data,
});
export const fetchAllForecastingDemandDropdownsFailure = (data) => ({
    type: types.GET_ALL_FORECASTING_DEMAND_DROPDOWNS_FAILURE,
    payload: data,
});

export const fetchForecastingDemandByIdWithPaginationRequest = (data) => ({
    type: types.GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_REQUEST,
    payload: data,
});
export const fetchForecastingDemandByIdWithPaginationSuccess = (data) => ({
    type: types.GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_SUCCESS,
    payload: data,
});
export const fetchForecastingDemandByIdWithPaginationFailure = (error) => ({
    type: types.GET_FORECASTING_DEMAND_BY_ID_WITH_PAGINATION_FAILURE,
    error,
});

export const fetchForecastDemandSitePriorityDrillthroughRequest = (data) => ({
    type: types.GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_REQUEST,
    payload: data,
});
export const fetchForecastDemandSitePriorityDrillthroughSuccess = (data) => ({
    type: types.GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_SUCCESS,
    payload: data,
});
export const fetchForecastDemandSitePriorityDrillthroughFailure = (error) => ({
    type: types.GET_FORECAST_DEMAND_SITE_PRIORITY_DRILLTHROUGH_FAILURE,
    error,
});

// export const SaveForecastingDemandReportsRequest = (data) => ({
//     type: types.SAVE_FORECASTING_DEMAND_REPORTS_REQUEST,
//     payload: data,
// });
export const SaveForecastingDemandReportsSuccess = (data) => ({
    type: types.SAVE_FORECASTING_DEMAND_REPORTS_SUCCESS,
    payload: data,
});
export const SaveForecastingDemandReportsFailure = (error) => ({
    type: types.SAVE_FORECASTING_DEMAND_REPORTS_FAILURE,
    error,
});

// Update Forecast Reducer
export const updateForecastReducer = (payload) => ({
    type: types.UPDATE_FORECAST_REDUCER,
    payload,
});

// Demand Table Tab Actions
export const fetchForecastFilterDropdownsRequest = () => ({
    type: types.FETCH_FORECAST_FILTER_DROPDOWNS_REQUEST
});
